import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { useCalendarStore } from '@uplift/contexts';
import { ProviderCancelSessionModal, SessionDetailsModal } from '@uplift/ui-v2';
import { DisplayName } from '@uplift/utils';
import { UserStatus } from '@uplift/types';
import { useQueryClient } from '@tanstack/react-query';


export const CalendarModals: React.FC = observer(() => {
  const queryClient = useQueryClient();
  const calendarStore = useCalendarStore();
  const [ patientDisplayName, setPatientDisplayName ] = useState<DisplayName>({ first: '', last: '' });
  const [ patientStatus, setPatientStatus ] = useState<UserStatus>();

  const appointment = React.useMemo(() => ({
    id: calendarStore.selectedEvent?.id,
    parentId: calendarStore.selectedEvent?.extendedProps?.parentId,
    patientId: calendarStore.selectedEvent?.extendedProps?.patientId,
    fromDatetime: calendarStore.selectedEvent?.extendedProps?.fromDatetime,
    isMaterialized: calendarStore.selectedEvent?.extendedProps?.isMaterialized,
  }), [ calendarStore.selectedEvent ]);

  return (
    <>
      <SessionDetailsModal
        open={calendarStore.modalsVisibility.details}
        onClose={() => calendarStore.closeModal('details')}
        onCancelSession={(_id, name, status) => {
          setPatientDisplayName(name);
          setPatientStatus(status);
          calendarStore.openModal('cancel');
        }}
        appointment={appointment}
        keepMounted
      />

      <ProviderCancelSessionModal
        open={calendarStore.modalsVisibility.cancel}
        appointmentId={calendarStore.selectedEvent?.id}
        parentId={calendarStore.selectedEvent?.extendedProps?.parentId}
        fromDatetime={calendarStore.selectedEvent?.extendedProps?.fromDatetime}
        onSubmit={async () => {
          await calendarStore.loadAllEvents(calendarStore._lastInfo, true, false);
          setPatientDisplayName(undefined);
          setPatientStatus(undefined);
          await queryClient.invalidateQueries({ queryKey: [ 'icsSubscription' ] });
        }}
        onClose={() => {
          calendarStore.closeModal('cancel');
        }}
        patientDisplayName={patientDisplayName}
        patientId={appointment.patientId}
        patientStatus={patientStatus}
      />
    </>
  );
});
